import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-52c47bce"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main-title"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "link-list"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "今日直播")], -1));

const _hoisted_3 = ["href"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "查看全部", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icongengduo"
}, null, -1));

const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LiveCard = _resolveComponent("LiveCard");

  return _openBlock(), _createElementBlock("div", {
    class: "live-container",
    style: _normalizeStyle({
      height: $props.bannerOpen ? '' : '218px'
    })
  }, [_createElementVNode("div", {
    class: "live-wrapper",
    style: _normalizeStyle({
      top: $props.bannerOpen ? '' : '0'
    })
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, $data.menu ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: `/live.html?menuId=${$data.menu.menu_id}&name=${$data.menu.module_name}`,
    class: "more-btn",
    style: {
      "margin-top": "4px"
    }
  }, _hoisted_6, 8, _hoisted_3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.liveList.slice(0, 2), (item, index) => {
    return _openBlock(), _createBlock(_component_LiveCard, {
      key: index,
      liveCount: $props.liveList.length,
      liveData: item,
      menu: $data.menu
    }, null, 8, ["liveCount", "liveData", "menu"]);
  }), 128))])], 4)], 4);
}